/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Method_Invite_HelpInputs */



/**
* | output |
* | --- |
* | "Send an invitation the user accepts with a password they choose." |
*
* @param {Members_Add_Method_Invite_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_method_invite_help = /** @type {((inputs?: Members_Add_Method_Invite_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Method_Invite_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sendet eine Einladung, die der Benutzer mit einem selbst gewählten Passwort annimmt.")
	return /** @type {LocalizedString} */ ("Send an invitation the user accepts with a password they choose.")
});